export default["__VITE_ASSET__OGkGJ7CB__","__VITE_ASSET__7pSrF9R3__"];